var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageApplication(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6914 11.2308L19.076 11.2308",
    stroke: "#4A4A4A",
    strokeWidth: 1.55,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53906 16H19.0775",
    stroke: "#4A4A4A",
    strokeWidth: 1.55,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53906 20.7692H19.0775",
    stroke: "#4A4A4A",
    strokeWidth: 1.55,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48618 5.15001H23.3708C23.8317 5.15001 24.2054 5.52367 24.2054 5.98462V15.523H25.7554V5.98462C25.7554 4.66763 24.6878 3.60001 23.3708 3.60001H5.48618C4.16919 3.60001 3.10156 4.66764 3.10156 5.98462V25.0615C3.10156 26.3785 4.16919 27.4462 5.48618 27.4462H23.3708C23.3771 27.4462 23.3833 27.4461 23.3896 27.4461H19.7936V25.8962H5.48618C5.02523 25.8962 4.65156 25.5225 4.65156 25.0615V5.98462C4.65156 5.52368 5.02523 5.15001 5.48618 5.15001Z",
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0346 24.5087C24.2863 24.5087 23.6797 23.9021 23.6797 23.1538C23.6797 22.4055 24.2863 21.7989 25.0346 21.7989C25.7829 21.7989 26.3895 22.4055 26.3895 23.1538C26.3895 23.5132 26.2467 23.8578 25.9926 24.1119C25.7385 24.366 25.3939 24.5087 25.0346 24.5087Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6371 25.9063V24.9972C28.6371 24.772 28.7265 24.5561 28.8857 24.397L29.5286 23.7541C29.8601 23.4226 29.8601 22.8851 29.5286 22.5536L28.8857 21.9107C28.7265 21.7515 28.6371 21.5356 28.6371 21.3105V20.4007C28.6371 19.9319 28.257 19.5519 27.7882 19.5519H26.8784C26.6533 19.5518 26.4374 19.4624 26.2782 19.3032L25.6353 18.6603C25.3038 18.3288 24.7664 18.3288 24.4349 18.6603L23.792 19.3032C23.6328 19.4624 23.4169 19.5518 23.1918 19.5519H22.2819C22.0567 19.5519 21.8407 19.6414 21.6815 19.8007C21.5223 19.96 21.4329 20.1761 21.4331 20.4014V21.3105C21.4331 21.5356 21.3437 21.7515 21.1845 21.9107L20.5416 22.5536C20.2101 22.8851 20.2101 23.4226 20.5416 23.7541L21.1845 24.397C21.3437 24.5561 21.4331 24.772 21.4331 24.9972V25.9063C21.4331 26.3751 21.8131 26.7552 22.2819 26.7552H23.1918C23.4169 26.7552 23.6328 26.8446 23.792 27.0038L24.4349 27.6467C24.7664 27.9782 25.3038 27.9782 25.6353 27.6467L26.2782 27.0038C26.4374 26.8446 26.6533 26.7552 26.8784 26.7552H27.7876C28.0128 26.7553 28.2289 26.666 28.3882 26.5068C28.5476 26.3476 28.6371 26.1316 28.6371 25.9063Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9213,
    cy: 8.24999,
    r: 1.34135,
    stroke: "#4A4A4A",
    strokeWidth: 0.894231
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79477 12.7212C8.79477 11.7334 9.59549 10.9327 10.5832 10.9327H13.2659C14.2537 10.9327 15.0544 11.7334 15.0544 12.7212L8.79477 12.7212Z",
    stroke: "#4A4A4A",
    strokeWidth: 0.894231,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageApplication);
export default __webpack_public_path__ + "static/media/manage-application.e7ab5ffe967a8432a4f4030e0c462117.svg";
export { ForwardRef as ReactComponent };